import { createContext } from 'react';
import type { Me } from '@/api/me';

export interface MeContextValue {
  me: Me;
  refetch: () => Promise<Me | void>;
}

export const MeContext = createContext<MeContextValue | null>(null);
